import React from "react";
import "./zoom.css"

class Zoom extends React.Component
{

    // slider entre 2 et 30 pour le zoom
    // this.duration = 9; // 5 secondes d'affichage par défaut
    constructor(props)
    {
        super(props);
        this.state = {
            duration: this.props.zoomValue,
        }
        this.handleSliderTimeLine =  this.handleSliderTimeLine.bind(this);
    }


    componentDidUpdate(prevProps) {
        if (prevProps.zoomValue !== this.props.zoomValue) {
            this.setState({
                duration: this.props.zoomValue
            });
        }
    }

    handleSliderTimeLine(event)
    {
        this.setState( {duration : event.target.value});
        if (this.props.onChangeZoom) this.props.onChangeZoom(event.target.value);
    }

    render()
    {
        return (
                    <div styles = {{width:"100%",height:"100%"}}>
                            <input type="range" min={3} id="zoomTimelineslider" 
                            className="zoomSliderTimeline" 
                            style={{background:"inherit"}} 
                            onInput={this.handleSliderTimeLine} 
                            onChange={this.handleSliderTimeLine} 
                            value={this.state.duration} 
                            max={30}/>


                    </div>
        )

    }

}

export default Zoom;